export * from "-!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EventCategory.vue?vue&type=template&id=fd19811a"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/EventCategory.vue?vue&type=template&id=fd19811a
// module id = 368
// module chunks = 0